<div class="pb-4 pt-4">
    <ng-container *ngIf="scheduleRows?.length > 0">
        <div class="flex pl-4 pr-4">
            <div
                class="text-old_silver box-border w-12 border-b border-solid border-[#d8d8d8] pb-1 text-xs font-medium dark:text-contrast-yellow">
                {{ 'HOUR' | translate }}
            </div>
            <div
                class="text-old_silver ml-5 box-border w-full border-b border-solid border-[#d8d8d8] pb-1 text-xs font-medium dark:text-contrast-yellow">
                {{ 'MINUTES' | translate }}
            </div>
        </div>

        <div
            class="flex pl-4 pr-4"
            *ngFor="let row of scheduleRows; let rowIndex = index"
            [ngClass]="{ 'row-with-next-upcoming-departure bg-white': isRowWithNextUpcomingDeparture(rowIndex) }">
            <div
                class="box-border w-12 border-b border-[#d8d8d8] pb-2 pt-2 font-bold"
                [ngClass]="{ 'border-solid': addBorderBottom(rowIndex) }">
                {{ row[0].valueOf() | momentDate: 'HH' : env.TIMEZONE }}
            </div>

            <div
                class="ml-5 box-border flex w-full border-b border-[#d8d8d8] pb-2 pt-2"
                [ngClass]="{ 'border-solid': addBorderBottom(rowIndex) }">
                <div
                    *ngFor="let hour of row; let timeIndexInRow = index"
                    [ngClass]="{
                        'ml-3': timeIndexInRow !== 0,
                        'text-ironside_grey': !isNextDeparture(rowIndex, timeIndexInRow),
                        'font-bold text-black dark:text-contrast-yellow': isNextDeparture(rowIndex, timeIndexInRow)
                    }">
                    {{ hour.valueOf() | momentDate: 'mm' : env.TIMEZONE }}
                </div>
            </div>
        </div>
    </ng-container>

    <div class="text-center" *ngIf="!scheduleRows || scheduleRows.length === 0">
        {{ 'NO_DEPARTURES_FOUND' | translate }}
    </div>
</div>
